import type { Release } from '../releases';

export default {
  id: '2026-11-03-resource-demand-days',
  at: '2026-11-04T09:35:00Z',
  title: 'Ресурсы: сколько людей и техники нужно по дням и сколько было на площадке',
  modules: ['resources', 'site'],
  items: [
    'На вкладке «Загрузка» проекта есть вид «По дням: план и факт»: для каждой профессии и вида техники — сколько нужно по графику на каждый день и сколько было на площадке. Прошедший день, когда людей или машин было меньше нужного, подсвечен красным.',
    'Факт берётся сам: люди — из табеля, куда часы пишет принятый отчёт смены, техника — из путевых листов и принятых отчётов смены. В подсказке ячейки — сколько людей на вахте и сколько по плану мобилизации.',
    'Первый принятый отчёт смены с работником отмечает его фактический заезд на вахту, если заезд ещё не отмечен.',
    'Стоимость потребности по дням видна тем, у кого есть доступ к суммам.',
  ],
  why: 'Потребность в людях была видна только по неделям и только против плана вахт: нельзя было увидеть, сколько людей и машин реально вышло в конкретный день, а заезд на вахту приходилось отмечать вручную.',
  link: '/resources',
} satisfies Release;
